import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/bookingChange';

import { load } from './utils';

export default function* listenLoad() {
  yield takeEvery(actions.load.toString(), load);
}
